<template>
  <div style="overflow:hidden;" class="mainbox">
    <div class="leftbox">
      <div class="leftboxmain" id="leftboxmain">
        <div class="roleleftbox">
          <dl class="roleleftdl">
            <dt>职业/标签</dt>
            <dd :class="nid == item.id ? 'active':''" v-for="(item,index) in leftroledata" :key="index">{{item.name}}</dd>
            <!-- <dd>游戏发烧友</dd>
            <dd>网络运营者</dd>
            <dd>程序员</dd>
            <dd>乐迷</dd>
            <dd>家庭煮fu</dd>
            <dd>宝妈/奶爸</dd>
            <dd>学生党</dd>
            <dd>产品经理</dd>
            <dd>摄影爱好者</dd>
            <dd>网购达人</dd>
            <dd>旅人/驴友</dd>
            <dd>自媒体人</dd>
            <dd>影剧粉</dd>
            <dd>新闻君</dd>
            <dd>求职/职场人</dd>
            <dd>医生/病患</dd> -->
          </dl>
        </div>
      </div>
    </div>
    <div class="rightbox">
      <div class="rightmainbox">
        <div class="fenleibiaoti">
          <h3>设计师</h3>
          <h2>在某个特定的专门领域创造或提供创意的工作，从事艺术与商业结合在一起的人</h2>
        </div>
        <div class="fenleimain">
          <div class="indexcell" id="b-word-baike">
            <table>
              <thead @click="gotolabellist">
                <tr>
                  <td>
                    <em>
                      <Icon type="ios-arrow-forward" />
                    </em>
                    <span>
                      <b></b>
                      <i>设计素材</i>
                    </span>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <ul>
                      <li @click="gotolabeldetails">
                        <span>
                          <img :src="anlismlogo" />
                          <i>9.2</i>
                        </span>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li @click="gotolabeldetails">
                        <span>
                          <img :src="anlismlogo" />
                          <i>9.0</i>
                        </span>
                        <dl>
                          <dt>
                            <img :src="blogo02" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li @click="gotolabeldetails">
                        <span>
                          <img :src="anlismlogo" />
                          <i>8.5</i>
                        </span>
                        <dl>
                          <dt>
                            <img :src="blogo03" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li @click="gotolabeldetails">
                        <dl>
                          <dt>
                            <img :src="blogo04" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li @click="gotolabeldetails">
                        <dl>
                          <dt>
                            <img :src="blogo05" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="indexcell" id="b-word-bangongruanjian">
            <table>
              <thead>
                <tr>
                  <td>
                    <em>
                      <Icon type="ios-arrow-forward" />
                    </em>
                    <span>
                      <b></b>
                      <i>设计软件</i>
                    </span>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <ul>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="indexcell" id="b-word-bama">
            <table>
              <thead>
                <tr>
                  <td>
                    <em>
                      <Icon type="ios-arrow-forward" />
                    </em>
                    <span>
                      <b></b>
                      <i>学习</i>
                    </span>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <ul>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="indexcell" id="b-word-biji">
            <table>
              <thead>
                <tr>
                  <td>
                    <em>
                      <Icon type="ios-arrow-forward" />
                    </em>
                    <span>
                      <b></b>
                      <i>设计图库</i>
                    </span>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <ul>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="indexcell" id="b-word-banjia">
            <table>
              <thead>
                <tr>
                  <td>
                    <em>
                      <Icon type="ios-arrow-forward" />
                    </em>
                    <span>
                      <b></b>
                      <i>设计工具</i>
                    </span>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <ul>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="indexcell" id="b-word-bitebi">
            <table>
              <thead>
                <tr>
                  <td>
                    <em>
                      <Icon type="ios-arrow-forward" />
                    </em>
                    <span>
                      <b></b>
                      <i>比特币/币圈</i>
                    </span>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <ul>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                      <li>
                        <dl>
                          <dt>
                            <img :src="blogo01" />
                          </dt>
                          <dd>
                            <h5>互动百科</h5>
                            <p>成就组织和个人使协作和管理更高效更愉悦</p>
                          </dd>
                        </dl>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="footerbox"></div>

    <div class="addwebbox">
      <addweb></addweb>
    </div>
    <BackTop :bottom="200" :right="25"></BackTop>
  </div>
</template>

<script>
import addweb from "../publish/addweb";
// import { getlistSimple } from "../../api/api";
export default {
  components: { addweb },
  data() {
    return {
      blogo01: require("@/assets/images/b-icon_001.jpg"),
      blogo02: require("@/assets/images/b-icon_002.jpg"),
      blogo03: require("@/assets/images/b-icon_003.jpg"),
      blogo04: require("@/assets/images/b-icon_004.jpg"),
      blogo05: require("@/assets/images/b-icon_005.jpg"),
      anlismlogo: require("@/assets/images/alsmlogo.gif"),
      nid:'',
      leftroledata:[],
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.nid = this.$route.query.id ? this.$route.query.id : ''
    //左边导航
    getlistSimple().then(res=>{
      if(res.code==200){
        this.leftroledata = res.data;
      }
      console.log('res',res)
    })

  },
  mounted() {

  },
  methods: {
    gotolabeldetails() {
      this.$router.push({
        name: "labeldetails"
      });
    },
    gotolabellist(){
      this.$router.push({
        name:'labellist'
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.mainbox {
  padding-top: 60px;
}
html,
body {
  height: 100%;
}
.roleleftbox {
    float: left;
    width: 250px;
    padding-top: 30px;
    .roleleftdl{ position: fixed; top:87px;}
    dl {
      padding-left: 75px;
      dt {
        font-size: 17px;
        font-weight: bold;
      }
      dd {
        font-size: 15px;position: relative;
        color: #333;
        margin-top: 10px; cursor: pointer; color: #333;
      }
      dd.active{
        color:#ffa200;
      }
      dd.active:before
        {
        content:"-";        
        color:#ffa200;
        font-weight:bold; width: 10px; font-size: 30px; position: absolute;
        left: -19px; top:-14px;
        }
      dd:hover{ color:#ffa200; }
    }
  }
.rightbox {
  width: 100%;
  min-height: 673px;

  .rightmainbox {
    padding-left: 250px;

    .mianbaoxie {
      padding-top: 15px;
    }

    ul.meitianul li {
      float: left;
      width: 22%;
      max-width: 355px;
      margin-right: 20px;
    }

    .dailyanlibox {
      overflow: hidden;
      h2 {
        font-size: 18px;
        padding-top: 30px;
        padding-bottom: 20px;
        font-weight: normal;
      }
      .dailylistbox {
        overflow: hidden;
        .alimgbox {
          img {
            max-width: 355px;
            max-height: 214px;
            width: 100%;
          }
        }
        .alimgname {
          padding-top: 8px;
          dl {
            dt {
              float: left;
              min-width: 50px;
              img {
                margin-left: 8px;
                margin-top: 8px;
              }
            }

            dd {
              float: left;
              width: 80%;
              h5 {
                font-size: 15px;
                font-weight: normal;
                color: #333;
              }
              p {
                color: #999;
                overflow: hidden;
                text-overflow: ellipsis;
                /*-webkit-text-overflow:ellipsis;*/
                white-space: nowrap;
              }
            }

            @media screen and (max-width: 1380px) {
              /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
              dd {
                float: left;
                width: 70%;
                h5 {
                  font-size: 15px;
                  font-weight: normal;
                  color: #333;
                }
                p {
                  color: #999;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  /*-webkit-text-overflow:ellipsis;*/
                  white-space: nowrap;
                }
              }
            }
          }
        }
      }
    }

    .fenleibiaoti {
      background: #f6f8f9;
      max-width: 1480px;
      width: 93.5%;
      margin-top: 20px;
      h3 {
        font-size: 20px;
        padding-left: 30px;
        padding-top: 20px;
      }
      h2 {
        font-size: 16px;
        padding-top: 15px;
        padding-left: 30px;
        padding-bottom: 25px;
        color: #999;
        font-weight: normal;
      }
    }

    .fenleimain {
      box-shadow: 0 0 3.5px #ddd;
      margin-top: 20px;
      max-width: 1480px;
      width: 93.5%;

      .indexcell {
        table {
          width: 100%;
          border-collapse: collapse;
          thead {
            background: #f6f8f9;
            line-height: 60px;
             em{ float:right; color: #ccc; font-size: 18px; padding-right: 20px;}
            b {
              display: inline-block;
              height: 15px;
              width: 3px;
              background: #505050;
            }
            span {
              font-size: 18px;
              margin-right: 10px;
              i {
                padding-left: 20px;
                font-size: 18px;
              }
            }
          }
          tbody {
            background: #fff;
            tr td {
              ul li {
                width: 25%;
                float: left;
                height: 95px;
                overflow: hidden;
                cursor: pointer;
                border: 1px solid #f3f3f9;
                position: relative;
                border-left: none;
                border-top: none;
                span {
                  position: absolute;
                  right: 0;
                  top: 0px;
                  background: #fff;
                  padding: 5px;
                  i {
                    float: left;
                    padding-left: 5px;
                    padding-right: 5px;
                    color: #999;
                  }
                  img {
                    float: left;
                    margin-top: 2px;
                  }
                }
                dl {
                  padding-top: 25px;
                  dt {
                    float: left;
                    width: 50px;
                    padding-left: 15px;
                    padding-top: 5px;
                  }
                  dd {
                    padding-left: 55px;

                    h5 {
                      font-size: 15px;
                      font-weight: normal;
                      color: #333;
                    }
                    p {
                      color: #999;
                      font-size: 12px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      /*-webkit-text-overflow:ellipsis;*/
                      white-space: nowrap;
                    }
                  }
                }
              }
              ul li:last-child {
              }
              ul li:first-child {
                border-left: none;
              }

              ul li:hover {
                box-shadow: 0 0 8px #ddd;
              }

              @media screen and (max-width: 1420px) {
                /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
                ul li {
                  width: 25%;
                }
              }
            }
          }
        }
      }
    }

    @media screen and (min-width: 1470px) and (max-width: 1840px) {
      .fenleimain {
        width: 92.5%;
      }
    }

    @media screen and (max-width: 1220px) {
      /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
      .fenleimain {
        width: 94%;
      }
    }
  }
}

.newword {
  display: inline-block;
  margin-left: 5px;
  width: 20px;
  line-height: 20px;
  background: #11be04;
  color: #fff;
  text-align: center;
}
.hotword {
  display: inline-block;
  margin-left: 5px;
  width: 20px;
  line-height: 20px;
  background: #ff0030;
  color: #fff;
  text-align: center;
}

.footerbox {
  height: 60px;
}

>>> .ivu-anchor-ink:before {
  background-color: #fff;
}
>>> .ivu-anchor-ink-ball {
  width: 18px;
  border-radius: 0;
  margin-top: 3px;
  background-color: #ffa200;
  border: 0 #fff solid;
  height: 3px;
  top: 8px;
  position: absolute;
}
.addwebbox {
  right: 30px;
  position: fixed;
  top: 38%;
}
@media screen and (max-width: 1300px) {
  .addwebbox {
    right: 15px;
    position: fixed;
    top: 38%;
  }
}

>>> .ivu-anchor-link-active > .ivu-anchor-link-title {
  color: #ffa200;
}
>>> .ivu-anchor-link > .ivu-anchor-link-title:hover {
  color: #ffa200;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/rolelist.vue